<template>
  <v-card>
    <v-card-title>
      {{ `${cashAccountGroup.displayGroup} (${cashAccountGroup.groupTag})` }}
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        dark
        small
        color="blue-grey lighten-2"
        @click="updateAccountsForAccountGroup"
      >
        Refresh <v-icon dark>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle
      ><v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field
    ></v-card-subtitle>
    <!-- ADD ':search="search"' to v-data-table if you'd like to key off it . . . otherwise gonna handle it manually -->
    <v-data-table
      :headers="headers"
      :footer-props="footerProps"
      :items="cashAccountGroupAccounts"
      :items-per-page="-1"
      no-data-text="Currently no accounts to display. . ."
      fixed-header
    >
      <template slot="item.acctCode" slot-scope="item">
        <v-chip
          @click="showTransactions(item.item)"
          class="account-name"
          color="blue darken-1 text--lighten"
          label
        >
          <v-icon x-small left>mdi-bank</v-icon>
          {{ `(${item.item.acctCode}) ${item.item.bank} ` }}
        </v-chip>
      </template>
      <template slot="item.summary.type" slot-scope="item">{{ item.item.acctType }}</template>
      <template slot="item.summary.balance" slot-scope="item">
        <span v-html="formatNumberForDisplay(item.item.summary.calculatedEndingBalance)"></span>
      </template>
      <template slot="item.summary.pending" slot-scope="item">
        <span v-html="formatNumberForDisplay(item.item.summary.clUnreconAmt)"></span>
      </template>
      <template slot="item.summary.projected" slot-scope="item">
        <span
          v-html="
            formatNumberForDisplay(
              parseFloat(item.item.summary.calculatedEndingBalance) +
                parseFloat(item.item.summary.clUnreconAmt)
            )
          "
        ></span>
      </template>
      <template slot="body.append">
        <tr class="landscape-totals">
          <th class="cash-value">Totals:</th>
          <th>
            <span></span>
          </th>
          <th class="cash-value">
            <span v-html="formatNumberForDisplay(balanceTotal)"></span>
          </th>
          <th class="cash-value">
            <span v-html="formatNumberForDisplay(pendingTotal)"></span>
          </th>
          <th class="cash-value">
            <span v-html="formatNumberForDisplay(projectedTotal)"></span>
          </th>
        </tr>
        <tr class="v-data-table__mobile-table-row portrait-totals">
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header">Balance Total</div>
            <div class="v-data-table__mobile-row__cell">
              <span v-html="formatNumberForDisplay(balanceTotal)"></span>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header">Pending Total</div>
            <div class="v-data-table__mobile-row__cell">
              <span v-html="formatNumberForDisplay(pendingTotal)"></span>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header">Projected Total</div>
            <div class="v-data-table__mobile-row__cell">
              <span v-html="formatNumberForDisplay(projectedTotal)"></span>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "cash-account-component",
  mounted() {
    // console.log("MOUNTING GUID: " + this.cashAccountGroup.generatedGUID);
    this.updateAccountsForAccountGroup();
  },
  data() {
    return {
      search: "",
      footerProps: { "items-per-page-options": [5, 10, 15, 25, 50, 100, -1] },
      headers: [
        {
          text: "Account",
          align: "start",
          sortable: false,
          value: "acctCode",
        },
        { text: "Type", value: "summary.type", sortable: false },
        { text: "Balance", value: "summary.balance", sortable: false, align: "right" },
        { text: "Pending", value: "summary.pending", sortable: false, align: "right" },
        { text: "Projected", value: "summary.projected", sortable: false, align: "right" },
      ],
    };
  },
  methods: {
    updateAccountsForAccountGroup() {
      this.$root.setBusy(
        "updateAccountsForAccountGroup",
        `Updating accounts for: ${this.cashAccountGroup.displayGroup}`
      );
      this.$store
        .dispatch("cashmanagement/updateAccountsForAccountGroup", {
          groupGUID: this.cashAccountGroup.generatedGUID,
        })
        .then((resp) => {
          // console.log("UPDATE RESPONSE: ", resp);
        })
        .finally(() => {
          this.$root.removeBusy("updateAccountsForAccountGroup");
          // console.log("UPDATED ACCOUNTS: ", this.cashAccountGroupAccounts);
          // console.log("UPDATED ACCOUNT GROUP???: ", this.cashAccountGroup);
        });
    },
    showTransactions(acct) {
      console.log("getTransactionsForAccount:", acct);
      this.$root.setBusy(
        "getTransactionsForAccount",
        `Getting transactions for account: ${acct.acctName}`
      );

      //FIXME: RESTORE ORIGINAL CODE
      this.$store
        .dispatch("cashmanagement/getTransactionsForGroupAccount", {
          groupGUID: this.cashAccountGroupGUID,
          acctId: acct.rid,
        })
        .then((accountWithTransactions) => {
          console.log("ACCOUNT W/ TRANSACTIONS:", accountWithTransactions);
          this.$router.push({
            name: "AccountTransactions",
            params: { account: accountWithTransactions },
          });
        })
        .finally(() => {
          this.$root.removeBusy("getTransactionsForAccount");
        });
    },

    isPortrait() {
      return this.isPortrait();
    },
  },
  props: {
    cashAccountGroupGUID: {
      //DETAIL: USING GUID RATHER THAN ACCOUNT GROUP BECAUSE WE splice() AND SWAP THEM OUT AS NEEDED
      type: String,
    },
  },
  computed: {
    cashAccountGroup() {
      return this.$store.getters["cashmanagement/cashAccountGroupByGUID"](
        this.cashAccountGroupGUID
      );
    },
    cashAccountGroupAccounts() {
      // return this.$store.getters["cashmanagement/accountsForcashAccountGroup"](this.cashAccountGroupGUID);
      return this.$store.getters["cashmanagement/accountsForCashAccountGroups"](
        this.cashAccountGroupGUID
      ).filter((acctGroup) => {
        return (
          `${acctGroup.acctCode + acctGroup.bank + acctGroup.acctType}`
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) >= 0
        );
      });
    },
    balanceTotal() {
      let balance = this.cashAccountGroupAccounts.reduce((acc, item) => {
        return acc + parseFloat(item.summary.calculatedEndingBalance);
      }, 0);

      return balance;
    },
    pendingTotal() {
      let pending = this.cashAccountGroupAccounts.reduce((acc, item) => {
        return acc + parseFloat(item.summary.clUnreconAmt);
      }, 0);

      return pending;
    },
    projectedTotal() {
      return this.balanceTotal + this.pendingTotal;
    },
  },
};
</script>

<style lang="postcss">
.v-tabs {
  border-radius: 0px !important;
}

.landscape-totals {
  background-color: #434343;
  color: white;
}
.cash-value {
  align-items: center;
  flex-wrap: nowrap;
  justify-content: end;
  width: 100%;
  padding-right: 0px;
  margin-right: 0px;
}
.account-name {
  color: white !important;
  font-weight: 400;
}

.v-data-table__mobile-row__header {
  margin-right: 20px !important;
}

@media screen and (orientation: portrait) and (max-device-width: 767px) {
  .portrait-totals {
    display: table-row;
  }

  .portrait-totals td {
    background-color: #434343 !important;
    color: whitesmoke !important;
    font-weight: bold !important;
  }

  .landscape-totals {
    display: none !important;
  }
}

@media screen and (orientation: landscape) {
  .landscape-totals {
    display: table-row;
  }
  .portrait-totals {
    display: none !important;
  }
}

@media only screen and (min-device-width: 768px) {
  .landscape-totals {
    display: table-row;
  }
  .portrait-totals {
    display: none !important;
  }
}
</style>
